import { JSX, useRef, useEffect, useState } from 'react';
import './windowBar.css'
import AddButton from './closeButton';

interface WindowBarProps {
    IconSrc: string,
    title: string,
    onClick: () => void,
    barRef?: React.RefObject<any>
    children?: React.ReactNode
}

const WindowBar = ({IconSrc, title, onClick, barRef, children}:WindowBarProps): JSX.Element => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const titleRef = useRef(null);

    useEffect(() => {
        if (titleRef.current) {
            const hasOverflow = titleRef.current.scrollWidth > titleRef.current.clientWidth;
            setIsOverflowing(hasOverflow);
        }
    }, [title]);

    return (
        <div className='window-bar' ref={barRef}>
            {IconSrc === null ? ( <></>) :(
                    <img src={IconSrc} alt="add icon" className="bar-icon"/>
                )}
            <div className='title-container'>
                <div ref={titleRef} className={`title-container ${isOverflowing ? 'overflow' : ''}`}>
                    <p ref={titleRef} className={`title ${isOverflowing ? 'overflow' : ''}`}>{title}</p>
                </div>
                {children}
            </div>
            <AddButton clickFunction={onClick}/>
        </div>
    );
};

export default WindowBar;